import { Link } from "@tanstack/react-router";
import { EditableText } from "@/components/site/EditableText";
import hero828 from "@/assets/hero-828.webp.asset.json";
import hero1280 from "@/assets/hero-1280.webp.asset.json";
import hero from "@/assets/hero.webp.asset.json";

export const heroSrcSet = `${hero828.url} 828w, ${hero1280.url} 1280w, ${hero.url} 1920w`;
export const heroSizes = "100vw";
export const heroPreloadHref = hero1280.url;
export const heroPreloadType = "image/webp";

/** <link rel="preload"> descriptor so the hero starts downloading with the HTML. */
export const heroPreloadLink = {
  rel: "preload",
  as: "image",
  href: heroPreloadHref,
  type: heroPreloadType,
  imageSrcSet: heroSrcSet,
  imageSizes: heroSizes,
  fetchPriority: "high",
} as const;

export function Hero() {
  return (
    <section className="relative isolate min-h-[85vh] flex flex-col items-center justify-start overflow-hidden">
      <img
        src={hero1280.url}
        srcSet={heroSrcSet}
        sizes={heroSizes}
        width={1920}
        height={1260}
        alt="Dr. Matthew Fitzer, bariatric surgeon serving Northern Virginia — Virginia Bariatric Surgery"
        fetchPriority="high"
        decoding="async"
        className="absolute inset-0 -z-10 h-full w-full object-cover"
      />
      <div className="w-full flex min-h-[40vh] sm:min-h-[45vh] flex-col items-center justify-center px-6 pb-6 text-center translate-y-[30px]">
        <h1 className="font-serif text-2xl sm:text-4xl md:text-5xl max-w-4xl leading-[1.05] text-[oklch(0.18_0.02_250)]">
          Bariatric Surgery &amp; Weight Loss Practice
          <br /> in <span className="text-primary italic">Northern Virginia</span>
        </h1>
        <EditableText
          as="p"
          contentKey="home.hero.subtitle"
          defaultValue="If you are considering weight-loss medication or an endoscopic or surgical procedure, we have the experience to make your goal weight a reality."
          multiline
          lineBreakClassName="block mt-[0.125em]"
          className="mt-2.5 max-w-2xl text-base md:text-lg leading-[1.365] text-[oklch(0.18_0.02_250)]/85"
        />
        <div className="mt-3.5 flex flex-wrap items-center justify-center gap-3">
          <Link to="/appointments" className="rounded-full bg-primary px-10 py-3 text-sm font-medium text-primary-foreground shadow-lg shadow-primary/20 hover:opacity-90">
            Request Appointment
          </Link>
          <Link to="/resources/insurance-coverage" className="rounded-full bg-brand-logo px-7 py-3 text-sm font-medium text-white shadow-lg shadow-brand-logo/20 hover:opacity-90">
            Check Surgery Coverage
          </Link>
          <Link to="/medical-weight-loss/insurance" className="rounded-full bg-brand-logo px-7 py-3 text-sm font-medium text-white shadow-lg shadow-brand-logo/20 hover:opacity-90">
            Check Medication Coverage
          </Link>
        </div>
      </div>
    </section>
  );
}
